export const env = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'f7cf5e5b-2488-4b70-adf8-f9b3fd010648',
  ENV: 'laChapelleSaintLuc',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 171,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
